import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { SessionsService } from '../services/sessions.service';

export function sessionInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const sessionsService = inject(SessionsService);

  const promise = sessionsService
    .getActiveSession()
    .then((activeSession) => {
      console.debug({
        message: 'Active session retrieved',
        session: activeSession,
        timeLeft: ((activeSession.expiresAt ?? new Date().getTime()) - new Date().getTime()) / 1000,
      });
      //Headers
      const headers = activeSession.accessCredentials?.httpHeaders ?? {};
      const headerPairs = Object.entries(headers);
      headerPairs.forEach(([key, value]) => req.headers.set(key, value));

      console.log(req.url);
      return;
    })
    .catch(() => {
      console.debug({
        message: 'No active session, waiting user action',
      });
    });

  return from(promise).pipe(() => next(req));
}
